<template>
  <div class="preloader-wrapper">
    <div class="preloader">
      <div class="loader" :style="loaderStyle">
        <svg class="spinner-svg" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle
            class="length"
            fill="none"
            :stroke-width="width"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="28"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VcvPreloader',

  props: {
    size: {
      type: [String, Number],
      default: 48
    },

    width: {
      type: [String, Number],
      default: 2
    }
  },

  computed: {
    loaderStyle() {
      return `width: ${this.size}px; height: ${this.size}px;`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/queries.scss';

$d: 175.6449737548828;

.preloader-wrapper {
  text-align: center;
}

.preloader {
  display: inline-block;
}

.loader {
  animation: contanim 2s linear infinite;
}

.spinner-svg {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;

  transform: rotate(-90deg);

  circle {
    stroke: $green;
    stroke-dasharray: 1, 300;
    stroke-dashoffset: 0;

    animation: strokeanim 3s calc(0.2s) ease infinite;
    transform-origin: center center;
  }
}

@keyframes strokeanim {
  0% {
    stroke-dasharray: 1, 300;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 120, 300;
    stroke-dashoffset: -$d / 3;
  }
  100% {
    stroke-dasharray: 120, 300;
    stroke-dashoffset: -$d;
  }
}

@keyframes contanim {
  100% {
    transform: rotate(360deg);
  }
}
</style>
